import React from "react";
import AppRoutes from "./app/routes/AppRoutes";

function App() {
  return <AppRoutes />;
}

export default App;